import React, { useState } from "react";

const HotelPageAccordion = ({data}) => {
  const [isAccordionOpen, setIsAccordionOpen] = useState(false);

  const handleAccordionToggle = () => {
    setIsAccordionOpen(!isAccordionOpen);
  };
  return (
    <div className="px-4">
      <button
        onClick={() => handleAccordionToggle()}
        className={`h-[56px] w-full  ${
          !isAccordionOpen && "border-b-[#0000000F] border-b-[1px]"
        } `}
      >
        <div className="flex justify-between h-full items-center">
          <div className="text-[#1A1A1A] text-[16px] leading-[24px]">
            {data.title}
          </div>
          {isAccordionOpen ? (
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18 15L12 9L6 15"
                stroke="#1A1A1A"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          ) : (
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5 7.5L10 12.5L15 7.5"
                stroke="#1A1A1A"
                stroke-width="1.66667"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          )}
        </div>
      </button>

      {isAccordionOpen && (
        <div
          onClick={() => handleAccordionToggle()}
          className={`w-full flex pb-4 justify-start ${
            isAccordionOpen && "border-b-[#0000000F] border-b-[1px]"
          }`}
        >
          <div className="w-full text-[#4D4D4D] text-[14px] leading-[18px] ">
            {data.text}
          </div>
        </div>
      )}
    </div>
  );
};

export default HotelPageAccordion;
